module.exports = __webpack_public_path__ + "static/media/Maf_banners-_industrias_1.4a95b7a4.jpg";